export default __webpack_public_path__ + "static/media/logo.a58ed61d.jpeg";